





























































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { MfaStatusEnum } from "@/shared/types";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { RawLocation } from "vue-router";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useMfaStore } from "@/shared/store/mfa";

@Component({
  components: {
    LoginWrapper,
    Input,
    GenericLoadingSpinner
  },
  props: {
    username: null,
    originalPassword: null
  }
})
export default class Login extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  mfaStore = useMfaStore();

  @Prop()
  MfaRouteFunc: (username: string, password: string, mfaStatus: MfaStatusEnum) => RawLocation;

  isSubmitting = false;

  @Prop()
  username: string;
  password = "";

  @Prop()
  originalPassword: string;
  confirmPassword = "";

  mfaCheck () {
    if (this.mfaStore.mfaStatus === MfaStatusEnum.Disabled) {
      return;
    }

    this.$router.push(this.MfaRouteFunc(this.username, this.password, this.mfaStore.mfaStatus));
  }

  @Watch("userStore.loggedIn")
  onLoggedIn (newValue, oldValue) {
    const url = this.userStore.isAdminPortal ? "/" : "onboarding/1";
    this.$router.push(url);
  }

  onSubmit () {
    this.$validator.validateAll()
      .then(result => {
        if (!result) return;
        this.isSubmitting = true;
        return this.userStore.setInitialPassword({
          username: this.username,
          originalPassword: this.originalPassword,
          newPassword: this.password
        });
      })
      .then(r => {
        this.mfaCheck();
        return r;
      })
      .catch(err => {
        this.isSubmitting = false;
        if (err && err.message) {
          this.notifierStore.setDanger(err.message);
        } else {
          this.notifierStore.setDanger("Unable to reset password");
        }
      });
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }

  get submitDisabled () {
    return this.isSubmitting === true;
  }

  get invalidState () {
    return !(this.username && this.originalPassword);
  }
}
